// deps
import React, { ReactElement, memo, useCallback, useMemo } from "react";

// interfaces
import { UpiPaymentMethod, PaymentMethodProps, IInAppUpiPaymentGroup } from "@payment-ui/interfaces";

// widgets
import { PaymentMethodListView } from "@payment-ui/widgets/payment-method-views/list-view";

// helpers
import { canEnablePaymentMethod } from "@payment-ui/helpers/Payment";

// test-ids
import { INAPP_UPI_ONBOARDING_PM_TEST_IDS } from "@swiggy-private/payment-test-ids";

export interface InAppUpiOnBoardingProps extends PaymentMethodProps {
    methodData: UpiPaymentMethod;
    paymentActions: IInAppUpiPaymentGroup["paymentActions"];
    paymentAmount: string;
    paymentAmountWithoutDiscount?: string;
    onClickInAppOnBoarding?: () => void;
    position?: number;
}

function InAppUpiOnBoarding(props: Omit<InAppUpiOnBoardingProps, "selected">): ReactElement {
    const { methodData, paymentActions, isPaymentGroupEnabled, onClickInAppOnBoarding } = props;

    const isMethodEnabled = useMemo(() => canEnablePaymentMethod(methodData, isPaymentGroupEnabled), [
        isPaymentGroupEnabled,
        methodData,
    ]);

    const onClick = useCallback((): void => {
        onClickInAppOnBoarding && onClickInAppOnBoarding();

        if (!isMethodEnabled) {
            return;
        }
        paymentActions.onSelect(props.methodData);
    }, [isMethodEnabled, paymentActions, props.methodData, onClickInAppOnBoarding]);
    return (
        <PaymentMethodListView
            methodData={props.methodData}
            isMethodEnabled={isMethodEnabled}
            onClick={onClick}
            onPayButtonClick={() => void 0}
            testIds={INAPP_UPI_ONBOARDING_PM_TEST_IDS}
            selected={false}
            payCtaMsg={""}
            showArrow={true}
        />
    );
}

export default memo(InAppUpiOnBoarding);
